import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function ActivityQuotaFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Set clear activity expectations for your team'
            subHeader='Help your sales reps thrive by setting activity quotas that guide their daily efforts and keep them motivated!'
            bullets={[
                'Defined activity goals help your team focus and reach their sales targets with confidence.',
                "Track each rep's activities against their quotas to recognize achievements and offer support.",
                'Assign individual quotas to foster accountability and drive success for everyone!',
            ]}
            feature='activityQuotas'
        />
    );
}
